// extracted by mini-css-extract-plugin
module.exports = {"Settings":"Settings_Settings__3LkFO"};